import {notification} from 'antd';
import CustomError from './CustomError';

const DefaultErrorMessage = 'Beklenmeyen bir hata oluştu. Lütfen daha sonra tekrar deneyin.';

export default function(message, err) {
    console.error(message, err);
    let description = undefined;
    if (err instanceof CustomError) {
        description = err.message || DefaultErrorMessage;
    } else if (typeof(err) === 'string') {
        description = err;
    }
    notification.error({message, description});
}
